import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function PrivacyPage() {
  const [cfg, setCfg] = useState({ contact_email: null, current_year: new Date().getFullYear() });
  useEffect(() => {
    const prev = document.title;
    document.title = "Privacy | Maxx Madison";
    fetch(`${BACKEND}/api/site/config`).then((r) => r.json()).then(setCfg).catch(() => {});
    return () => { document.title = prev; };
  }, []);

  return (
    <div className="min-h-screen bg-[#0b0a09] font-[Inter] text-[#efe7d9]">
      <div className="mx-auto max-w-2xl px-6 py-16 sm:px-10">
        <a href="/" data-testid="privacy-back" className="font-mono text-xs uppercase tracking-[0.2em] text-[#c9a227] hover:underline">&larr; Back</a>
        <h1 className="mt-8 font-serif text-4xl tracking-tight">Privacy Policy</h1>
        <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-[#efe7d9]/75">
          <div>
            <h2 className="font-serif text-xl text-[#efe7d9]">What we collect</h2>
            <p className="mt-2">When you join the reader list, we collect your email address and, optionally, your first name. We also record the date you signed up and the date you gave consent.</p>
          </div>
          <div>
            <h2 className="font-serif text-xl text-[#efe7d9]">Why we collect it</h2>
            <p className="mt-2">We use this information solely to send you occasional updates about Maxx Madison and House Diamond &mdash; publication news, excerpts, cover reveals, and early-access opportunities. We do not sell or share your information with third parties.</p>
          </div>
          <div>
            <h2 className="font-serif text-xl text-[#efe7d9]">How it is stored</h2>
            <p className="mt-2">Your information is stored securely in our application database. If we later connect an email delivery platform, your data may also be processed by that provider strictly to deliver these emails.</p>
          </div>
          <div>
            <h2 className="font-serif text-xl text-[#efe7d9]">Unsubscribe &amp; deletion</h2>
            <p className="mt-2">You may unsubscribe at any time using the link in any email we send. To request deletion of your information{cfg.contact_email ? <> , contact us at <a href={`mailto:${cfg.contact_email}`} className="text-[#c9a227] hover:underline">{cfg.contact_email}</a></> : " , contact us"} and we will remove your record promptly.</p>
          </div>
        </div>
        <div className="mt-12 border-t border-white/5 pt-6 text-xs text-[#efe7d9]/45">&copy; {cfg.current_year} Maxx Madison. All rights reserved.</div>
      </div>
    </div>
  );
}
